import { render, staticRenderFns } from "./CustomerPaymentTypes.vue?vue&type=template&id=70303f30&scoped=true&"
import script from "./CustomerPaymentTypes.vue?vue&type=script&lang=js&"
export * from "./CustomerPaymentTypes.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPaymentTypes.vue?vue&type=style&index=0&id=70303f30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70303f30",
  null
  
)

export default component.exports